import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { LandingService } from "../../landing/landing.service";
import Swal from "sweetalert2";

declare global {
  interface Window {
    FB: any;
  }
}

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  public year: number = new Date().getFullYear();
  config;
  licenses = [];
  profileFacebook: string;
  informacion: any = {
    real_estate_id: 1,
    nombre: null,
    correo: null,
    telefono: null,
    mensaje: null,
  };

  url = environment.URL_AWS;
  constructor(private _router: Router, private _LandingService: LandingService) {
    var host = window.location.host;
    const domain = host.split(".")[1];
    let data;
    if (domain == "in-mo" || domain == "inmoapp") {
      data = {
        domain: host.split(".")[0],
      };
    } else {
      data = {
        domain: environment.DOMAIN,
      };
    }
    this._LandingService.getConfig(data).then(
      (data: any) => {
        console.log("getConfig RESP footer.component.ts", data);
        this.config = data;
        this.config.phone1 = this.config.phone1.slice(-10);

        const dataToSend = {
          real_estate_id: this.config.real_estate_id,
        };
        this._LandingService.getLicenses(dataToSend).then(
          (dataLic: any) => {
            this.licenses = dataLic.data;
            console.log("getLicenses RESP footer.component.ts", dataLic.data);
          },
          (error: any) => {
            console.log("getLicenses ERROR footer.component.ts", error);
          }
        );
        // if (window.FB && window.FB.init) {
        //   window.FB.init({ status: true, xfbml: true, version: 'v5.0' });
        // } else {
        //   window.FB.XFBML.parse(document.getElementById('facebookSocial'));
        // }

        //
      },
      (error: any) => {
        console.log("getConfig ERROR footer.component.ts", error);
      }
    );
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.config?.fbUrl) {
      this.profileFacebook = this.config?.fbUrl.replace("https://www.facebook.com/", "");
      this.profileFacebook = this.profileFacebook.replace("/", "");

      let app = document.getElementById("frameFace");

      app.innerHTML =
        "<iframe src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F" +
        this.profileFacebook +
        "' width='340' height='500' style='border:none;overflow:hidden' scrolling='no' frameborder='0' allowfullscreen='true' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'></iframe> </ng-container>";
    }
  }

  redirectSN(typSN: number) {
    switch (typSN) {
      case 1:
        window.open(this.config.instagramUrl, "_blank");
        break;
      case 2:
        window.open(this.config.tikTokUrl, "_blank");
        break;
      case 3:
        window.open(this.config?.fbUrl, "_blank");
        break;
    }
  }

  privacyPolicy() {
    // this._router.navigate(['/privacy_policy']);
    const routeUrl = this._router.serializeUrl(this._router.createUrlTree(["/privacy_policy"]));
    window.open(routeUrl, "_blank");
  }

  nom247() {
    // this._router.navigate(['/privacy_policy']);
    const routeUrl = "https://www.dof.gob.mx/nota_detalle.php?codigo=5646251&fecha=22/03/2022#gsc.tab=0";

    window.open(routeUrl, "_blank");
  }

  async contactoRealEstate() {
    this.informacion.real_estate_id = this.config?.real_estate_id;
    this.informacion.desde = window.location.href;
    console.log("DATA contactoRealEstate", this.informacion);
    var data = this.informacion;
    this.informacion = {
      real_estate_id: this.config?.real_estate_id,
      nombre: null,
      correo: null,
      telefono: null,
      mensaje: null,
    };
    await this._LandingService
      .contactoRealEstate(data)
      .then(
        (resp: any) => {
          console.log("RESP sendInformation", resp);
          Swal.fire("Correcto", "Información mandada con exito", "success");
        },
        (error: any) => {
          console.log("Error de servidor APR", error);
          // Swal.fire('Error de servidor APR ', error?.error?.message+'<br>'+error?.error?.errores, 'error');
          Swal.fire(
            "Error de servidor APR",
            "" +
              (error?.error?.errores
                ? error?.error?.errores
                : error?.error?.mensaje
                ? error?.error?.mensaje
                : error?.error?.text),
            "error"
          );
        }
      )
      .finally(() => {});
  }
}
